import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../api/axios';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';
import GoogleAuthButton from '../components/GoogleAuthButton';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    } else if (!/[A-Z]/.test(formData.password)) {
      newErrors.password = 'Password must contain at least one uppercase letter';
    } else if (!/[0-9]/.test(formData.password)) {
      newErrors.password = 'Password must contain at least one number';
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password';
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await API.post('/api/auth/register', {
        email: formData.email.toLowerCase(),
        password: formData.password,
      });

      const { user, token, refresh_token } = response.data;
      login(user, token, refresh_token);
      navigate('/email-verification');
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Registration failed. Please try again.';
      setErrors({ submit: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  const passwordStrength = () => {
    if (!formData.password) return 0;
    let strength = 0;
    if (formData.password.length >= 8) strength++;
    if (/[A-Z]/.test(formData.password)) strength++;
    if (/[0-9]/.test(formData.password)) strength++;
    if (/[!@#$%^&*]/.test(formData.password)) strength++;
    return strength;
  };

  const strengthColor = {
    0: '#ccc',
    1: '#ff6b6b',
    2: '#ffa500',
    3: '#4ecdc4',
    4: '#27ae60',
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Godly Match</h1>
          <p>Join the community</p>
        </div>

        {errors.submit && (
          <div className="error-banner">{errors.submit}</div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
              className={errors.email ? 'input-error' : ''}
              disabled={loading}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                className={errors.password ? 'input-error' : ''}
                disabled={loading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {errors.password && <span className="error-text">{errors.password}</span>}

            {formData.password && (
              <div className="password-strength">
                <div className="strength-bar">
                  <div
                    className="strength-fill"
                    style={{
                      width: `${(passwordStrength() / 4) * 100}%`,
                      backgroundColor: strengthColor[passwordStrength()],
                    }}
                  ></div>
                </div>
                <span className="strength-text">
                  {passwordStrength() === 0 && 'Very weak'}
                  {passwordStrength() === 1 && 'Weak'}
                  {passwordStrength() === 2 && 'Fair'}
                  {passwordStrength() === 3 && 'Good'}
                  {passwordStrength() === 4 && 'Strong'}
                </span>
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <div className="password-input-wrapper">
              <input
                type={showConfirm ? 'text' : 'password'}
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="••••••••"
                className={errors.confirmPassword ? 'input-error' : ''}
                disabled={loading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                {showConfirm ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={loading}
          >
            {loading ? 'Creating account...' : 'Sign Up'}
          </button>
        </form>

            {/* Place this after your existing form submit button */}
<div style={{
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  margin: '16px 0'
}}>
  <hr style={{ flex: 1, borderColor: '#ddd' }} />
  <span style={{ color: '#999', fontSize: '13px' }}>or</span>
  <hr style={{ flex: 1, borderColor: '#ddd' }} />
</div>

<GoogleAuthButton label="Continue with Google" />

        <div className="auth-footer">
          <p>Already have an account? <Link to="/">Log in</Link></p>
        </div>

        <div style={{
          textAlign: 'center',
          marginTop: 12,
          paddingTop: 12,
          borderTop: '1px solid #f0f0f0',
          fontSize: 12,
          color: '#999'
        }}>
          <a href="/privacy" style={{ color: '#C8102E', textDecoration: 'none' }}>Privacy Policy</a>
          {' · '}
          <a href="/terms" style={{ color: '#C8102E', textDecoration: 'none' }}>Terms of Service</a>
          {' · '}
          <a href="/community-guidelines" style={{ color: '#C8102E', textDecoration: 'none' }}>Guidelines</a>
        </div>

      </div>
    </div>
  );
}

